export default {
  "+wet4N": "Памылка праверачнага кода",
  "2QzYmY": "Адмена",
  "32AbcK": "Выберыце кампанію",
  "4R5GEq": "Дадому",
  "9Kfib+": "Невядомая памылка",
  "9UZxwP": "Калі ласка, увядзіце праверачны код",
  "9cYMNA": "Інфармацыя аб кампаніі",
  "9ljNkr": "Адправіць",
  "9vpYSL": "Выдаліць кампанію",
  "EWMpn/": "Выдаліць ролю",
  FEb7U2: "Пацвердзіць",
  "J3BW/8":
    "Калі ласка, увядзіце код спраўджання, які вы атрымалі па электроннай пошце",
  "QK/hAI": "Дазволы прагляду",
  TqDOFU: "Калі ласка, не дасылайце коды спраўджання часта!",
  XeiAal: "Выдаліць",
  aiBGBs: "Выдаліць пасьпяхова",
  azDNha: "Адпраўлена паспяхова",
  "e/6XZC": "Не атрымалі код спраўджання?",
  jNxbTC: "Код спраўджання не можа быць пустым",
  l1fZNE: "Немагчыма зняць усе галачкі",
  "2MYr1m": "уваход",
  "lzP/we": "спампаваць",
  m0Qdyj: "Памылка праверкі",
  nJCPaY:
    "Карыстальнік не мае прывязанага адраса электроннай пошты і не можа быць правераны",
  x79O39: "Вы ўпэўненыя, што хочаце выдаліць?",
  xxETOY: "Канфігурацыя дазволу да дадзеных кампаніі",
  yGWx2z: "Памылка параметру",
  Unvxiq: "Пераключыць уліковы запіс",
  ggvI6Z: "Выбраць усё",
  lKbhpS: "Перыяд абнаўлення адценняў шэрага прылады (мясцовы час)",
  ayUfs1: "Час заканчэння не можа быць ранейшы за час пачатку",
  "03eM6t": "200 элементаў/старонку",
  "7/cUwn": "Прамежак часу для абнаўлення прылады (мясцовы час)",
  SGDlQ6: "Усяго {total} элементаў",
  "arp+TQ": "50 элементаў/старонку",
  e8OyHO: "20 элементаў/старонку",
  iyOrrD: "100 элементаў/старонку",
  yXsHgv: "10 элементаў/старонку",
  "+/R6RX": "Статус задачи",
  "+0SHNk": "MAC-адрес Wi-Fi",
  "+4lD9e": "Имя",
  "+74JfZ": "Пример: Device_000001_Gaoqiao Store_Android.",
  "+7V2pl": "общий",
  "+CLSks":
    "2. Тип системы устройства, к которому применяется это правило именования.",
  "+GQdfc": "UpdateToken",
  "+L9lak": "Применить шаблон тревоги",
  "+TzicH": "магазин",
  "+gbx50": "Состояние тревоги",
  "+kHAfa": "Пожалуйста, заполните данные магазина",
  "+m8vFq": "Детали правила именования",
  "/8GfsH": "Четыре",
  "/99v4N": "Все магазины",
  "/CxA3j": "Добавить дополнительный магазин",
  "/Qlgz9": "Загрузите устройство Windows",
  "/SqqyP": "Введите серийный номер устройства",
  "/cqdKk": "скачать",
  "/sI6h+": "люди",
  "0KH9Qi": "Тип системы устройства",
  "0VK6Tv": "Статус бизнеса",
  "0YYUNG": "Выбрано {num} тегов",
  "0iTEVO": "Посмотреть токен",
  "0uRy1k": "один",
  "11uVJ/": "Получить объект",
  "19+woq": "Подробности о магазине",
  "1M03Dq": "Шаблон расписания",
  "1PtjRr": "Имя устройства",
  "1SslIM": "Закрыть приложение",
  "1X8SYs": "Широта и долгота",
  "1sAivX": "MAC-адрес Ethernet",
  "1sj5Sj": "Удалить все шаблоны расписаний, примененные к этому устройству.",
  "2/LdaO": "Сохранение информации о конфигурации",
  "2JW1Pt":
    "Пожалуйста, выберите, отправлять ли электронные письма одновременно",
  "2nV3tA": "Магазин не выбран",
  "2opnVU": "Во время исполнения",
  "2qrsN7": "Пожалуйста, выберите адрес магазина",
  "2r/XUW": "Удалить все шаблоны расписаний, примененные этим тегом.",
  "3HzQUc": "Экспорт JSON",
  "3QXG/d": "Ора версия",
  "3XHWMy": "Четверг",
  "3aYG4L":
    "Удалите шаблон сигналов тревоги, примененный в данный момент к устройству, и больше не отслеживайте и не отправляйте сигналы тревоги.",
  "3h+3Xm": "Не открыт для бизнеса",
  "3jyOjJ": "Следует ли изменить выбранное устройство на «Зарегистрированное»",
  "3qF993":
    "Вы не можете передать устройство, которое не является частью вашей нынешней компании.",
  "4/e9qs": "Пожалуйста, заполните имя",
  "4Xdib8": "Период времени не может быть пустым",
  "4c3uw8": "Выйти из магазина",
  "4vWL+W": "Импортировать устройство",
  "4wi+/p": "шаблон",
  "5+oaTO": "Статус последнего обновления изображения",
  "5Cm9U3": "Уведомление о сообщении",
  "5Hy0Qx": "Невозможно перенести в тот же магазин.",
  "5KtG4i": "Поиск бизнеса",
  "5WKL9+": "Выберите статус магазина",
  "5jpkHg": "онлайн-статус",
  "5p8cBO": "Управление аккаунтом",
  "5ytYaf": "Добавить новый шаблон расписания",
  "6+iYA0": "серийный номер",
  "60Ixlm": "Имя шаблона сигналов тревоги",
  "6eB+xj": "Пожалуйста, выберите конкретного пользователя",
  "6pDRb2": "Пожалуйста, введите действительный пароль",
  "7ip592": "1. Имя правила именования",
  "88CuCZ":
    "3. Установить метод наименования оборудования, зарегистрированного в этом магазине (автоматически заполнять имя оборудования)",
  "8PESa6": "Запрещать",
  "8huAxo": "Добавить новое правило",
  "8u3CYe": "Название правила именования",
  "8usMqO": "Удалить объявление",
  "8zN+hZ": "Выполнить приложение",
  "9/Vb7e": "Загрузить устройство",
  "919TK9": "Поддерживаемые форматы: xls, xlsx.",
  "9AsSO/":
    "Пожалуйста, выберите, отправлять ли текстовые сообщения одновременно",
  "9UefLp": "Этикетка",
  "9g6s9o": "Пожалуйста, введите код магазина",
  "9iKk2b": "Стартовый номер",
  "9r00YD": "Управление объявлениями",
  "9w+ho+": "счет",
  "9yRpjk": "Суббота",
  "A/eXwT": "Удалить все шаблоны сигналов тревоги, примененные к этому ярлыку.",
  A5kf1W: "Весь список компаний",
  ANeFu6: "Подтвердить пароль",
  Abqe2U: "Адрес магазина",
  Axagls: "Пожалуйста, выберите время окончания",
  AyWMlZ: "Добавить запланированную задачу",
  B57Wbu: "Устройство не выбрано",
  BBpRbn: "Удалить все шаблоны сигналов тревоги, примененные к этому магазину.",
  BC74I9: "Подсказка",
  BQcLxf: "двигаться вниз",
  BYbqwY: "Перетащите файл сюда или нажмите «Загрузить».",
  BwXapw:
    "Пожалуйста, контролируйте название категории в пределах 500 символов.",
  C6cGK1: "Название шаблона расписания не может быть пустым.",
  CLqPBU: "редактировать",
  CPTAAj: "Увеличение натуральных чисел",
  D5HOUz: "Выберите статус",
  DADacD: "Удалить все шаблоны расписаний, примененные к этому магазину.",
  DFyP1k: "Закрыть магазин",
  DxGUhN: "Выбрать все устройства",
  E1GPl7: "владелец",
  EGvInA: "Список сигналов устройства",
  EM8lAi:
    "Обновляемый период времени по оборудованию компании (по местному времени)",
  "EO+Nlk": "Файл загружается, пожалуйста, не закрывайте диалоговое окно.",
  EwM8Kj: "Вы уверены, что хотите уехать?",
  Ey9rBq: "Вы уверены, что хотите удалить его?",
  F2LJDJ: "Вы уверены, что хотите удалить?",
  F3ndvv: "Удаление не удалось",
  FBH89G: "модифицированная версия",
  FNIJXx: "Пожалуйста, выберите прокрутку воспроизведения",
  "FaJ/jI": "Файл для импорта не выбран",
  FbCeo1: "триггерное значение",
  FbsCUK: "сотовый телефон",
  "Fr1I/b": "этикетка",
  Ft60hS: "Нубис оборудование",
  G4XFn6: "Модель оборудования",
  G4qgGm: "все пользователи",
  G5gg2V: "Необходимо указать заголовок объявления",
  G6i1QR: "Выберите адрес",
  G9APSK: "Изменить правила именования",
  Gk0Mt5:
    "Вы уверены, что хотите сбросить настройки ({name}) устройства сигнализации? Правила сигналов тревоги продолжат отслеживаться после сброса.",
  GnzEo7: "время последнего обновления изображения",
  GujK99:
    "Если содержимое шаблона тревоги будет обновлено позже, оно также будет синхронизировано с примененным устройством.",
  Gwj7xc: "Восстановить настройки по умолчанию",
  H5s58g: "24 часа",
  HN1dNJ: "Все аккаунты",
  HOHQFs: "Название правила именования не может быть пустым.",
  HRXYJB: "Все компании",
  "HdxQ2/": "Файлы конфигурации, связанные с хранилищем, и правила именования",
  "Hv/pfB": "Вторник",
  I37xbU: "Пожалуйста, заполните",
  ITbo35: "Название магазина не может быть пустым!",
  IqkgWZ: "Ключевые слова",
  "Iwt/8W": "аннотация",
  "J0D5h+": "время начала",
  J9jPRL: "Скопировано успешно",
  JJl2M9: "Экспорт",
  JLMIof: "Загрузите Android-устройство",
  JRhVym: "Рабочее время не может быть пустым.",
  JeJAmT: "Переименовать",
  Jh62y5: "Все устройства",
  Jp7u8z: "башня",
  KJHvMA: "Управление магазином",
  KlWMzW: "Активировано",
  Km733q: "Пожалуйста, выберите время начала",
  Kwqd8h: "Контактное лицо",
  L24ioQ: "заголовок",
  L80hmc: "Название объявления не должно превышать 30 символов.",
  LNGTru: "Список ошибок планирования устройства",
  LWSLHa: "Добрые советы",
  Lfia0v: "Настроить расписание",
  "LuP+H0": "описывать",
  LwhdsE: "Переключить множественный выбор",
  M404r0: "два",
  MZ5Ei7: "Период времени пересекается с {num}-м периодом времени",
  MmsEyp: "зарегистрироваться",
  MnTdIi: "Количество триггеров",
  N52KMq: "Подробный адрес",
  NGs9sO: "возвращаться",
  "NM/lRq": "Отменить загрузку",
  NjB2tN: "Пожалуйста, выберите бизнес-статус!",
  OMcnk6: "Производитель",
  OSqnZu: "Следует ли изменить выбранную версию устройства на",
  "OZGX3+": "Список объявлений",
  OaZpDP: "UUID",
  OcijhH: "Серийный номер материнской платы",
  OsMncl: "Не включено",
  "P/eul9": "нет",
  PVmkgT: "Пожалуйста, введите короткое имя",
  PaMvre: "Список правил тревоги",
  PnYplH: "оборудование",
  PrIueu: "Открыто 24 часа",
  "Py/5UG":
    "Управляемый узел больше не существует, пожалуйста, запустите его снова.",
  "Q+0CDu": "Добавьте правила именования",
  "Q2/NzC": "Выбрано {num} устройств",
  QHc9Qg: "Содержание объявления",
  QHhMxE: "Выберите роль",
  QLYuf8: "Все компании",
  QV3pnn: "состояние",
  QpOtgZ: "Название магазина",
  Qpcx6F: "Требуется содержание объявления",
  Qpi3DY: "день",
  "QsAe0/": "Сохранить не удалось",
  QwHI8Q: "Результаты запроса:",
  R2D5Dv: "время создания",
  RCjVsb: "Идентификатор устройства",
  RNaGVr: "Список неудачных задач",
  RQyKsa: "Анонс платформы",
  RWBRyt: "Карта распределения оборудования находится в разработке",
  RndUeh: "Предполагаемое время выполнения",
  RyXQqJ: "Время загрузки",
  S1QSWC: "Импортировать в дополнительный магазин",
  S57QRB: "Фильтровать по",
  SbZhau: "В задаче загрузки необходимо указать загрузочное устройство.",
  SkK50H: "Пожалуйста, добавьте запланированную задачу",
  SwMBFl: "Применить шаблон расписания",
  T3CtvK: "Название категории не может быть пустым.",
  TDSTTj: "Выберите шаблон расписания",
  TDuPUp: "Сработало",
  TLZPhr: "Понедельник",
  TYAJpp: "Выбрано {num} магазинов",
  UA7mv6: "Время последнего обновления Ора",
  UBbWUL: "Шаблон не выбран",
  UZ49sl: "Телефон ответственного лица",
  UtE0dS: "действовать",
  "Uu/nFu":
    "Удалить все шаблоны сигналов тревоги, примененные к этому устройству.",
  V0RiZp: "Операция прошла успешно",
  Vd3wZV: "общий",
  Ve9Ksw: "Переместить магазин",
  ViVQNi: "Роль",
  VqEr9u: "Количество магазинов, в которые можно подать заявку",
  Vx4M25: "код магазина",
  "W/wIZ8": "ответственное лицо",
  WYHxWn: "три",
  WYtW9Y: "Пожалуйста, выберите версию",
  WdyIyo: "Время работы",
  WtPk7v: "Отправляйте СМС одновременно",
  WxPZOH: "Выполнить {num} раз",
  WypzMq: "Запланированные задачи",
  Wzv7kF: "Пожалуйста, выберите магазин",
  X2PYza: "Сведения об устройстве",
  "XKj/en": "Серийный номер биоса",
  "XLdI1+": "Мощность Wi-Fi",
  XMBOec: "Удалить тег",
  XPFi6q: "полоска",
  XmRKnc: "Примечание",
  YYGRyG: "Пожалуйста, загрузите вложения",
  YeF1dY: "часовой пояс",
  YpXN8m: "Время последнего срабатывания",
  YwEzx2: "Проверьте поля, которые необходимо отобразить",
  ZGYHyC: "Время начала не может быть пустым.",
  ZQ91U9: "Дом",
  ZUPzqr: "включать",
  ZdO12B: "Подать заявку в магазин",
  "Zvt+2g": "складирование",
  aBleoN: "Выберите шаблон сигнала тревоги",
  aGxRt2: "содержание",
  "aN+DgN": "время активации",
  akvGrq: "Настроить правила",
  askOz5: "Поиск адреса",
  "b+Dz+s": "Список всех магазинов",
  b5l2vN: "сохранять",
  bBz42a: "обновить статус",
  "bE+h3K": "Статус устройства",
  bFBjSK: "пять",
  bOKDVF: "Переключить радио",
  biXcnk: "Электронная почта ответственного лица",
  bqbDVw: "Запрос",
  bzfrYI: "Конфигурация объявлений",
  cDZ00w: "Проверять",
  "cZ9/ZC": "Удалить [{имя}]?",
  cawvIS: "Последнее обновление",
  cgIBtg: "Выберите верхний уровень",
  cr1ymH: "Пожалуйста, выберите время отправки",
  "d7i/AT": "верхний слой",
  dEXfrL: "Интервал состояния работоспособности устройства",
  dGBGbt: "все",
  drCsUI: "компания",
  eAgY2G: "Расширить дочерние компании",
  eCCa0L: "Тип задачи",
  "eP/37G": "Время регистрации",
  eeCxuz: "Тип ОС",
  evJP5c: "Правила именования",
  f7Dpbl: "Скачайте шаблон и улучшите контент согласно подсказкам шаблона.",
  "fc12+X": "Пятница",
  fz2pkM: "Узел удален",
  gU4eZD: "Управление тревогами",
  gmUXEi: "Характеристика оборудования",
  gnNjS5: "Имя личного устройства",
  gpg5DN: "Посмотреть объявление",
  gplM71: "ежедневно",
  "gyh+d1": "проводная сеть",
  "h/j3a5": "Контактный номер телефона",
  h7w4pz: "Данных пока нет",
  "hD7/Lu": "показывать",
  "hDx3/S": "Почта",
  hEI4G8: "Новое объявление",
  hYN7oM: "скрывать",
  hkJXyi: "Настройка запланированных задач",
  i5MLJc: "Последнее обновление: {lastUpdate}",
  "i6kDf/":
    "Если выбранное устройство содержит {num} версий Nubis Free, команды устройства будут недоступны.",
  iKomBu: "Классификации пока нет",
  iN7Lps: "циклический режим",
  ich0wH: "Номер устройства",
  ifGp4v: "2ФА",
  "j/YGZ0": "карта",
  j3QWSE:
    "Начальное число для приращения натурального числа может быть только положительным целым числом.",
  j6m8Si: "Контактный адрес электронной почты",
  jAAXdQ: "Магазин оборудования",
  jT6zKT: "Количество устройств",
  "jhfb/7": "Сохранено успешно.",
  js3tZs: "Название шаблона расписания",
  k7dy8j: "Связанные файлы конфигурации",
  k9dozc: "Время выполнения",
  kG2Etz: "онлайн",
  khyRcw: "Пожалуйста, выберите файл Excel",
  "kr+7Iy": "Поиск магазина",
  l36W55: "прокрутка воспроизведения",
  lK6HPZ: "Пожалуйста, выберите статус магазина",
  lVgYx7: "Приостановленный",
  lllhRf: "Время окончания не может быть пустым.",
  loTFGc: "Безымянный",
  m1h20o:
    "Если содержимое шаблона расписания будет обновлено позже, оно также будет синхронизировано с примененным устройством.",
  mFIXSq: "Серийный номер устройства",
  mKKd1R: "Пожалуйста, выберите получателей",
  "mYa6W/": "Пользовательский текст",
  ma6S6y: "Пользовательский дисплей",
  mn0ceu:
    "Существуют повторяющиеся правила конфигурации, пожалуйста, измените их.",
  "mpeFt+": "Правила тревоги",
  nGubXb: "Подробности шаблона расписания",
  nUSeQB: "Аккаунт не выбран",
  nzsNwZ: "Состояние здоровья устройства",
  "o+O5d1": "Пожалуйста, выберите задание",
  o5OLcm: "Аббревиатура магазина",
  o8tJYm: "команда устройства",
  o9lryN: "Воскресенье",
  "oFt+cN": "Тест скорости сети",
  oW4Uka: "назначать",
  obfTaf: "Конфигурация магазина",
  ojz0Ke: "Посмотреть больше >",
  oru5FY: "Изменить шаблон расписания",
  "p/3Nn5": "мобильная сеть",
  pBPyFt: "Нубис-версия",
  pK94Zd: "Импортировать в магазин",
  "pV2t/S": "Основная информация",
  pXEyon: "Тип устройства",
  peNVzr: "каждые {num} недель",
  peUIwk: "Создать объявление",
  pfGGi0:
    "Удалите шаблон расписания, примененный в данный момент к устройству, и больше не выполняйте его.",
  pielKO: "Загрузочное устройство",
  q6qKtH: "Условия запроса:",
  q9PHLT: "Пока нет объявлений",
  q9YGIf: "Бизнес",
  qDba8m: "Статус автономного устройства",
  qUKj7E: "копировать",
  qUiH5y: "Правила конфигурации не могут быть пустыми.",
  "qqwM/t": "Конфигурационный файл",
  qyh9hz: "Часы работы",
  "r0/TUu": "Конечно",
  "r2dEd/": "перезагрузить",
  rAKRwm: "Выберите версию устройства",
  rDRAr0: "Версия операционной системы",
  s1l1Jq: "Управление магазином и аккаунтом",
  s7NSze:
    "Пожалуйста, введите пароль своей учетной записи перед подтверждением операции.",
  s9U9qn: "Установить будильник",
  sGYTej: "отдых",
  sOIerB: "Не активировано",
  sVsXUO: "Среда",
  sZSyGZ: "давать возможность",
  srEpKw: "Загрузка",
  srpWCM:
    "Отметьте поля, которые необходимо отобразить, и перетащите их для сортировки.",
  t5gffJ: "Информация об оборудовании",
  tugHWJ: "Вернуться к списку объявлений",
  u3dVQz: "еженедельно",
  ubuOXs: "Зарегистрирован",
  ujBeLh: "Публичное уведомление системы технического обслуживания",
  "uoZwj+": "Создатель",
  uuRzdk: "Принадлежать магазину",
  v04auv: "время окончания",
  vD5wnY:
    "Проверьте магазин, к которому вы хотите принадлежать, что означает, что у вас есть разрешение магазина.",
  vDCwZ9: "Загрузить файлы",
  vr5TVT: "Пожалуйста, введите",
  wOHHSJ: "двигаться вверх",
  wQAiLI: "Сбросить напоминание",
  wYygRu: "отправитель",
  "wrU/Kc": "каждые {num} дней",
  x34QXR: "Время окончания не может быть раньше времени начала.",
  xI0mPJ: "Уже включено",
  xISm1t: "активация",
  xUjLTE: "поиск",
  xXdMar: "Укажите пользователя",
  xuf2rG: "Все магазины",
  xx40g7: "Название объявления",
  "y+WxsP": "Редакционное уведомление",
  yKFvYY: "Отправляйте электронные письма одновременно",
  yOMNOj: "да",
  yReEcE: "Выберите ярлык",
  yb3AuG: "Оффлайн",
  ybGQQ3: "Нет соответствующих результатов",
  yc6ZUL: "Последнее обновление статуса Ora",
  ydktLD: "разделитель",
  yeCGlM: "шесть",
  yfhtRM: "приложение",
  ygAHaf: "Отправить время",
  yy7EDI: "загрузить",
  zftpop: "Выберите пользователя",
  znuEgQ: "Добавить часы работы",
  zok1hp: "Слот C",
  zvaxmN: "Управление расписанием",
  zyMKgy: "Выберите магазин",
  o5QBKU: "компанияУспешноОбновлена",
  "1yM7WW": "Удалить выбранное устройство?",
  DqB8kg: "Удалить устройство",
  QH21BX: "Пакетная регистрация устройств",
  TlDh4N: "Пакетное удаление устройств",
  UcumBq: "Уведомление о тревоге",
  X9zJwr: "Назначать устройства пакетно",
  lkP6UV: "Обновить устройство",
  wLyMu9: "Улучшите контент согласно подсказкам шаблона",
  FQM81K: "Изменить статус выбранного магазина следующим образом",
  WqfGVu: "Ограничено 30 словами",
  hV5chR: "Пожалуйста, выберите, следует ли открывать всплывающее окно",
  vD7UHb: "Всплывающее окно",
  "0Drg5o": "Я согласен с вышеуказанными условиями",
  "7pY6K/": "Условия и положения",
  CNkomH: "Редакционные условия",
  CoaQps: "Управление терминами",
  "HHA/d7": "Список терминов",
  UH1kCc: "Добавить",
  "VzqtN+": "Требуются положения и условия",
  hOtsIx: "Новая статья",
  ilUpPP: "Вернуть список терминов",
  "j+y4w+": "Требуется заголовок термина",
  j4CmNU: "Просмотреть условия",
  jJg298: "Название статьи",
  t4lrWD: "Заголовок статьи не должен превышать 30 символов",
  z7A1Fc: "Создать условия",
  "OY+bYK": "Подтвердить, больше не показывать",
  "+d1f6p": "Загрузить устройство Linux",
  UrM0bR: "Информация для аутентификации",
  "+uAolt": "Пример: разрешить пользователям легко настраивать заголовки, значки и текст веб-сайтов для персонализации веб-сайта.",
  "0UAhKu": "Пример: https://nubiscloud.freshdesk.com/support/home",
  "0h3ZUE": "Загрузка в Центр учётных записей",
  "0lEh3g": "Загрузка в Nubis Space",
  "0xMj0V": "Пример: Предоставьте новую версию или обновите образ устройства",
  "3DMdxJ": "Изменить вкладку DeviceCenter",
  "4ImW13": "Пример: Управление магазином",
  "52LsQF": "Пример: Центр учётных записей",
  "5BTra1": "Пример: Платформа",
  "61gplm": "Загрузка текста",
  "6sZvzw": "Заменить ключевые слова в Центре устройств",
  "7bKyxU": "Загруженные изображения будут сохранены в файловом браузере Nubis Drive. Повреждение или удаление файла приведёт к ошибке загрузки изображения",
  "7q8OJE": "Изменить платформу",
  "8TfVSD": "Изменить платформу Вкладка",
  "8pToBN": "Пример: Cloud",
  "9/8z30": "Позволить пользователям легко настраивать название, значок и текст веб-сайта для персонализации веб-сайта",
  "9C+wuW": "Пример: Управление устройствами",
  "D1cAYC": "Пример: Центр устройств",
  "FKBH20": "Пример: Nubis Space",
  "G+eQYn": "Пример: Управление магазином и учётными записями",
  "G2LkOf": "Загрузка управления объявлениями",
  "I9uxGU": "Пример: Глобальный сервис, воплощение ваших идей, предоставление интеллектуального опыта",
  "K1Xqdl": "Пример: Управление разрешениями",
  "LTVlAP": "Загрузка в Центр обновлений",
  "Q1/SUP": "Пример: Открытое уведомление о системе обслуживания",
  "QAN35o": "Пример: Управление устройствами, мониторинг, удалённое управление, и т. д.",
  "R8nCNR": "Загрузить в раздел Управление устройствами",
  "TVuUjT": "Ora",
  "U08bUN": "Загрузить в Центр устройств",
  "Wu2nnZ": "Знакомство с платформой",
  "ZP1/uy": "Пример: Управление разрешениями ролей платформы Nubis",
  "ayjmy+": "Пример: Управление устройствами и группами по всему миру",
  "bhXvJB": "Загрузка управления разрешениями",
  "cAIDk5": "Центр поддержки",
  "d3b8dv": "Загрузка персонализированного управления",
  "dFHONh": "Nubis",
  "dWy8l5": "Пример: Ora",
  "fZJ9SZ": "Пример: Управление учетными записями ваших партнеров и клиентов",
  "jAmQmn": "Пример: Центр разработки",
  "kwx95y": "Пример: Персонализированное Управление",
  "ov96O9": "Персонализированное управление",
  "rM4ciX": "Пример: Управление объявлениями",
  "uDYj3x": "Центр веб-сайтов",
  "uRrPru": "Загрузка управления магазином",
  "vdUVb9": "Пример: Центр обновлений",
  "xrKftB": "Загрузка значка",
  "2IaM+V": "Центр обновлений",
  "EoXhnk": "Центр устройств",
  "JeSd9K": "Другое",
  "wzIKok": "Наследует персонализированные настройки компании верхнего уровня",
  "BQDKvZ": "Пример: Агент",
  "EO9pTF": "Пример: Облако",
  "/NrLZv": "Количество лицензий",
  "1Dklb3": "Дата автоматического вступления в силу",
  "1dyq46": "CMS",
  "1t0NXU": "Дата оплаты",
  "2DbIoa": "Информация о заказе",
  "2hUF5M": "Выберите хотя бы 1 лицензию",
  "2qqw4C": "Продавец",
  "3Y6eOz": "Истек срок действия",
  "5FboZ/": "Тип",
  "6bBRd8": "Электронная почта клиента",
  "6jMfox": "Получены записи о заказе",
  "D0cpCO": "Количество лицензий",
  "EBMdAL": "Создано успешно",
  "FDRhoz": "Отправлено",
  "G0UYbD": "Выберите лицензии",
  "GCrD1e": "Осталось дней",
  "JeSd9K": "Другое", "JmnNA0": "Необязательное поле",
  "LG70v2": "Отправить запись заказа",
  "NZQWZL": "Формально",
  "PjtWQX": "Выбрано {num} лицензий",
  "Plhuph": "Поиск номера заказа, номера ERP",
  "Rrwy85": "Создатель",
  "TX6jKq": "Получатель",
  "U+pKlD": "Удалить номер заказа: {name}?",
  "Xvn+2E": "Контактное лицо клиента",
  "YII2+w": "Срок действия",
  "YJbxtM": "Полученная компания",
  "ZIJmYm": "Управление заказами",
  "ZTs8/J": "Создать лицензии",
  "a7AYs5": "Срок действия (дней)",
  "eM8o1Y": "Заказ Номер",
  "eUSpdN": "Подробнее",
  "er7lkB": "Сумма", "fyjje7": "Лицензионный ключ",
  "gqvOsW": "Контактное лицо клиента", "iTiIWl": "Совпадающие данные не найдены",
  "k1xuGk": "Поиск номера заказа",
  "kPb1Wj": "НОМЕР ERP",
  "lfUbAE": "Активен",
  "mPsm6o": "Тестирование",
  "ouraCD": "Управление устройством",
  "pUL1dA": "Удалить заказ",
  "pecEGk": "Отмена",
  "sTreBL": "Фактическая дата вступления в силу",
  "sbThvA": "Отправлено компанией",
  "svGx//": "Введите действительный номер",
  "tMGiGt": "Тип лицензии",
  "tsV2n0": "Создать заказ",
  "twizE+": "Электронная почта продавца",
  "u6rHwS": "Дата формирования заказа",
  "vePxOp": "Обычный", "wNYTXq": "Не используется",
  "wawZXM": "Статус лицензии",
  "xVTk70": "Загрузка",
  "xxFsds": "Обязательные поля",
  "0axARa": "Дата истечения срока действия",
"0tqhdw": "Менеджеры и выше будут получать электронные письма от [{x}] компаний, всего [{y}] компаний.",
"4DfIa5": "Выбранный тип лицензии не должен быть бета-версией.",
"4kc3eS": "В первый день каждого месяца система будет отправлять электронное письмо о статусе лицензий или устройств, требующих уведомления. Электронное письмо будет содержать следующую информацию.",
"7FTqlN": "Нет соответствующих лицензий.",
"AfMAI0": "Устройство, имеющее лицензию, автоматически получит новую лицензию по истечении срока действия текущей лицензии.",
"FQjcoc": "Правила автоматизации лицензирования",
"GDWKlf": "Серийный номер сопряженного устройства",
"Iqlkbs": "Выбранный статус лицензии должен быть не используется",
"K5iYC8": "Неиспользованные лицензии, срок автоматической активации которых истечет в течение следующих 100 дней.",
"NBz0wZ": "Лицензии, которые в настоящее время активны, но не назначены ни одному устройству.",
"URkpah": "Истекшие лицензии",
 "UjxKxu": "Завершено",
"VaAWfW": "Лицензии с более близкими датами автоматического истечения срока действия имеют более высокий приоритет",
"Wp2PXY": "Настройки уведомлений",
"X2YceA": "Неиспользуемые лицензии",
"ZLqStU": "Предварительно импортированные устройства автоматически получат лицензии после регистрации",
"daUauj": "Лицензионный ключ, номер заказа, серийный номер сопряженного устройства",
"eFFkgE": "Обзор инвентаризации лицензий",
"eHMGvf": "Пожалуйста, выберите лицензию",
"eR85km": "Устройство с авторизованной лицензией, срок действия которой истекает в течение следующих 100 дней. Если срок действия лицензии истекает и замена лицензии не предоставляется, устройство будет переведено в зарезервированный статус.",
"fTfy0b": "Система автоматически применит лицензии в соответствии с правилами автоматизации лицензирования",
"ftSBnR": "Парная лицензия",
"lLC16+": "Управление лицензиями",
"lQGDqR": "Устройство уже находится в зарезервированном или приостановленном статусе.",
"lTtEaU": "Зарезервировано", "t0EXqz": "Действующие лицензии",
"vPHZLC": "Включает дочерние компании",
"xy6tQS": "Устройство, зарегистрированное через OR-код или API, будет автоматически лицензировано",
"zE041n": "Дата истечения срока действия",
"FQQECq": "Обязательно",
"ekxzlF": "Имя"
};
